import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 管理员审批事项列表
export const getAdminAuditList = (params: any) => request({
  url: '/manage/manager-review-task',
  method: 'get',
  params
})

// 管理员审批事项
export const setAdminAuditInfo = (data: any) => request({
    url: '/manage/manager-review-task/' + data.task_id,
    method: 'patch',
    data
})

// 导出
export const tableExport = (data: any) => request({
  url: '/manage/manager-review-task/export' + objToUrlParams(data),
  method: 'post'
})